(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-pdp-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-lp-pdp-bundle]');
    if (!roots.length) return;

    // Mismo formato que el filtro money (placeholder de shop.money_format),
    // para el monto de "Ahorrás".
    function formatMoney(cents, format) {
      function withDelimiters(amount, precision, thousands, decimal) {
        var parts = (amount / 100).toFixed(precision).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
      }
      var fmt = format || '${' + '{amount}}';
      var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return fmt;
      var value;
      switch (match[1]) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return fmt.replace(match[0], value);
    }

    // La caja solo marca y cuenta: el total (producto + complementos) lo
    // calcula la card de compra, que también los agrega al carrito con su
    // botón principal. Cada cambio se avisa con lp:bundle:change.
    function setupBundle(root) {
      var inputs = root.querySelectorAll('[data-lp-pdp-bundle-addon-input]');
      var hint = root.querySelector('[data-lp-pdp-bundle-hint]');
      var summary = root.querySelector('[data-lp-pdp-bundle-summary]');
      var countEl = root.querySelector('[data-lp-pdp-bundle-count]');
      var savingsEl = root.querySelector('[data-lp-pdp-bundle-savings]');

      function refresh() {
        var count = 0, savings = 0;
        inputs.forEach(function (inp) {
          var on = inp.checked && !inp.disabled;
          var row = inp.closest('[data-lp-pdp-bundle-addon]');
          if (row) row.classList.toggle('is-selected', on);
          if (!on) return;
          count++;
          var price = parseInt(inp.getAttribute('data-price'), 10) || 0;
          savings += (parseInt(inp.getAttribute('data-price-full'), 10) || price) - price;
        });
        if (hint) hint.hidden = count > 0;
        if (summary) summary.hidden = count === 0;
        if (countEl) {
          countEl.textContent = count === 1
            ? countEl.getAttribute('data-label-one')
            : (countEl.getAttribute('data-label-many') || '').replace('__COUNT__', count);
        }
        if (savingsEl) {
          savingsEl.hidden = savings <= 0;
          savingsEl.textContent = (savingsEl.getAttribute('data-label') || '')
            .replace('__AMOUNT__', formatMoney(savings, savingsEl.getAttribute('data-money-format')));
        }
        document.dispatchEvent(new CustomEvent('lp:bundle:change', { detail: { count: count } }));
      }

      inputs.forEach(function (inp) {
        inp.addEventListener('change', refresh);
        var row = inp.closest('[data-lp-pdp-bundle-addon]');
        if (!row) return;
        row.addEventListener('click', function (e) {
          if (inp.disabled || e.target.closest('a, select, label')) return;
          inp.click();
        });
      });

      // Complementos con variantes: el select define qué variante y precio
      // se suman.
      root.querySelectorAll('[data-lp-pdp-bundle-variant]').forEach(function (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var row = select.closest('[data-lp-pdp-bundle-addon]');
          if (!opt || !row) return;
          var inp = row.querySelector('[data-lp-pdp-bundle-addon-input]');
          var nowEl = row.querySelector('[data-lp-pdp-bundle-price-now]');
          var wasEl = row.querySelector('[data-lp-pdp-bundle-price-was]');
          if (inp) {
            inp.setAttribute('data-variant-id', opt.value);
            inp.setAttribute('data-price', opt.getAttribute('data-price'));
            inp.setAttribute('data-price-full', opt.getAttribute('data-price-full'));
          }
          if (nowEl) nowEl.textContent = opt.getAttribute('data-money');
          if (wasEl) wasEl.textContent = opt.getAttribute('data-money-full');
          refresh();
        });
      });

      refresh();
    }

    roots.forEach(setupBundle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-buy-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var cards = document.querySelectorAll('[data-lp-buy-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.getAttribute('data-lp-bound') === 'true') return;
      card.setAttribute('data-lp-bound', 'true');

      var mode = card.getAttribute('data-mode');

      var variantChips = card.querySelectorAll('[data-lp-variant-chips] .lp-pdp-buy-card__chip');
      var variantInput = card.querySelector('[data-lp-variant-input]');
      var priceEl = card.querySelector('[data-lp-price]');
      var comparePriceEl = card.querySelector('[data-lp-compare-price]');
      var installEl = card.querySelector('[data-lp-installments]');

      // Sin Shopify.formatMoney (este tema no lo carga) el formato se copia de
      // un precio que ya rindió el filtro money del servidor: símbolo,
      // separador de miles y decimal. Antes caía a "$128.25" en una tienda
      // que muestra "$128,25".
      var moneySample = '';
      var sampleEl = card.querySelector('[data-variant-price-money]');
      if (sampleEl) moneySample = sampleEl.getAttribute('data-variant-price-money') || '';
      if (!moneySample && priceEl) moneySample = priceEl.textContent || '';

      function moneyFormat(cents) {
        try {
          if (window.Shopify && window.Shopify.formatMoney) {
            return window.Shopify.formatMoney(cents, window.Shopify.money_format);
          }
        } catch (e) {}
        var sample = moneySample.trim();
        var prefix = (sample.match(/^[^\d]*/) || [''])[0];
        var decMatch = sample.match(/([.,])\d{2}$/);
        var decSep = decMatch ? decMatch[1] : ',';
        var thouSep = decSep === ',' ? '.' : ',';
        var fixed = (cents / 100).toFixed(decMatch || !sample ? 2 : 0).split('.');
        var intPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
        return prefix + intPart + (fixed[1] ? decSep + fixed[1] : '');
      }

      function renderInstallments(newPriceCents) {
        if (!installEl) return;
        var tpl = installEl.getAttribute('data-installments-template') || '';
        var count = parseInt(installEl.getAttribute('data-installments-count'), 10);
        if (!tpl || !count || isNaN(count) || count < 2 || isNaN(newPriceCents) || newPriceCents <= 0) return;
        var perInst = Math.floor(newPriceCents / count);
        var out = tpl
          .replace('{count}', String(count))
          .replace('{amount}', moneyFormat(perInst));
        installEl.textContent = out;
      }

      // Misma regla que el Liquid: entero grande + ",20" en un span más chico,
      // solo si el string termina en separador decimal + 2 dígitos.
      function renderPrice(formatted) {
        if (!priceEl || !formatted) return;
        var text = String(formatted).trim();
        var match = text.match(/^(.+?)([.,]\d{2})$/);
        priceEl.textContent = match ? match[1] : text;
        if (match) {
          var dec = document.createElement('span');
          dec.className = 'lp-pdp-buy-card__price-dec';
          dec.textContent = match[2];
          priceEl.appendChild(dec);
        }
      }

      var stockEl = card.querySelector('[data-lp-stock]');
      function renderStock(available) {
        if (!stockEl) return;
        stockEl.textContent = stockEl.getAttribute(available ? 'data-in-label' : 'data-out-label') || '';
        stockEl.classList.toggle('is-out', !available);
      }

      variantChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.getAttribute('aria-disabled') === 'true') return;
          variantChips.forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');

          var vid = chip.getAttribute('data-variant-id');
          var variantId = parseInt(vid, 10);
          if (variantInput && vid) {
            variantInput.value = vid;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          var newPrice = parseInt(chip.getAttribute('data-variant-price'), 10);
          var priceFormatted = chip.getAttribute('data-variant-price-money');
          renderPrice(priceFormatted);

          var compareFormatted = chip.getAttribute('data-variant-compare-money');
          if (comparePriceEl && compareFormatted) {
            comparePriceEl.textContent = compareFormatted;
          }

          renderInstallments(newPrice);

          var availableAttr = chip.getAttribute('data-variant-available');
          var available = availableAttr === 'true';
          renderStock(available);

          var mediaIdAttr = chip.getAttribute('data-media-id');
          var mediaId = null;
          if (mediaIdAttr) {
            var parsedMediaId = parseInt(mediaIdAttr, 10);
            mediaId = isNaN(parsedMediaId) ? null : parsedMediaId;
          }

          document.dispatchEvent(new CustomEvent('lp:variant:change', {
            bubbles: true,
            detail: {
              variantId: isNaN(variantId) ? null : variantId,
              variantPrice: isNaN(newPrice) ? null : newPrice,
              priceFormatted: priceFormatted || null,
              available: available,
              mediaId: mediaId
            }
          }));
        });
      });

      // With volume tiers the chips are replaced by lp-pdp-volume-tiers, which
      // emits the same lp:variant:change event. Mirror the headline price /
      // installments off the event so the card stays in sync either way.
      document.addEventListener('lp:variant:change', function (e) {
        if (!e.detail) return;
        // Con "Desde" el precio es el mínimo y no sigue a la presentación.
        if (e.detail.priceFormatted && !card.querySelector('.lp-pdp-buy-card__price-from')) {
          renderPrice(e.detail.priceFormatted);
        }
        renderInstallments(e.detail.variantPrice);
      });

      var stepper = card.querySelector('[data-lp-stepper]');
      if (stepper) {
        var qtyInput = stepper.querySelector('[data-lp-qty-input]');
        var decBtn = stepper.querySelector('[data-lp-qty-dec]');
        var incBtn = stepper.querySelector('[data-lp-qty-inc]');

        function clampQty() {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 1) v = 1;
          qtyInput.value = v;
        }

        if (decBtn) {
          decBtn.addEventListener('click', function () {
            if (!qtyInput) return;
            var v = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = Math.max(1, v - 1);
          });
        }
        if (incBtn) {
          incBtn.addEventListener('click', function () {
            if (!qtyInput) return;
            var v = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = v + 1;
          });
        }
        if (qtyInput) {
          qtyInput.addEventListener('change', clampQty);
          qtyInput.addEventListener('blur', clampQty);
        }
      }

      // Total del botón = precio × cantidad + complementos marcados en la caja
      // "Complementá tu compra". Se avisa por lp:pdp:total para que la barra
      // fija de mobile muestre lo mismo.
      var addBtn = card.querySelector('[data-lp-add-cart]');
      var buyForm = card.querySelector('[data-lp-buy-form]');
      var addTotalEl = card.querySelector('[data-lp-add-total]');
      var unitPrice = addBtn ? parseInt(addBtn.getAttribute('data-unit-price'), 10) || 0 : 0;

      function checkedAddons() {
        return Array.prototype.filter.call(
          card.querySelectorAll('[data-lp-pdp-bundle-addon-input]'),
          function (inp) { return inp.checked && !inp.disabled && inp.getAttribute('data-variant-id'); }
        );
      }

      function currentQty() {
        var field = buyForm && buyForm.querySelector('[data-lp-qty-input]');
        var q = field ? parseInt(field.value, 10) : 1;
        return isNaN(q) || q < 1 ? 1 : q;
      }

      function cartItems(mainId) {
        var items = [{ id: mainId, quantity: currentQty() }];
        checkedAddons().forEach(function (inp) {
          items.push({ id: parseInt(inp.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
        return items;
      }

      function updateTotal() {
        if (!addBtn) return;
        var addons = checkedAddons();
        var total = unitPrice * currentQty();
        addons.forEach(function (inp) { total += parseInt(inp.getAttribute('data-price'), 10) || 0; });
        var formatted = moneyFormat(total);
        if (addTotalEl) addTotalEl.textContent = ' · ' + formatted;
        var bundleTotal = card.querySelector('[data-lp-pdp-bundle-total]');
        if (bundleTotal) bundleTotal.textContent = formatted;
        document.dispatchEvent(new CustomEvent('lp:pdp:total', {
          detail: { total: total, formatted: formatted, addons: addons.length }
        }));
      }

      document.addEventListener('lp:variant:change', function (e) {
        if (e.detail && typeof e.detail.variantPrice === 'number') unitPrice = e.detail.variantPrice;
        updateTotal();
      });
      document.addEventListener('lp:bundle:change', updateTotal);
      if (buyForm) {
        buyForm.addEventListener('input', updateTotal);
        buyForm.addEventListener('click', function (e) {
          if (e.target.closest('[data-lp-qty-dec], [data-lp-qty-inc]')) updateTotal();
        });
      }
      updateTotal();

      function addState(state) {
        document.dispatchEvent(new CustomEvent('lp:pdp:add-state', { detail: { state: state } }));
      }

      // "Comprar ahora" con complementos marcados: el envío nativo solo lleva
      // el producto, así que se agregan todos y se va al pago.
      var buyNowBtn = card.querySelector('[data-lp-buy-now]');
      if (buyNowBtn && buyForm) {
        buyNowBtn.addEventListener('click', function (e) {
          if (!checkedAddons().length) return;
          if (!window.lpCart || typeof window.lpCart.addItems !== 'function') return;
          var idInput = buyForm.querySelector('input[name="id"]');
          var id = idInput ? parseInt(idInput.value, 10) : NaN;
          if (isNaN(id)) return;
          e.preventDefault();
          buyNowBtn.disabled = true;
          window.lpCart.addItems(cartItems(id))
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () { buyNowBtn.disabled = false; });
        });
      }

      // "Agregar al carrito" agrega sin salir de la página; solo "Comprar
      // ahora" (name="checkout") sigue con el envío nativo que lleva al pago.
      if (addBtn && buyForm) {
        var addLabel = addBtn.querySelector('[data-lp-add-label]');
        var setAddLabel = function (name) {
          if (addLabel) addLabel.textContent = addBtn.getAttribute('data-label-' + name) || addLabel.textContent;
        };
        addBtn.addEventListener('click', function (e) {
          if (!window.lpCart || typeof window.lpCart.addItems !== 'function') return;
          e.preventDefault();
          if (addBtn.disabled) return;
          var idInput = buyForm.querySelector('input[name="id"]');
          var id = idInput ? parseInt(idInput.value, 10) : NaN;
          if (isNaN(id)) return;

          addBtn.disabled = true;
          addBtn.setAttribute('aria-busy', 'true');
          if (addTotalEl) addTotalEl.hidden = true;
          setAddLabel('loading');
          addState('loading');
          window.lpCart.addItems(cartItems(id))
            .then(function () { setAddLabel('added'); addState('added'); })
            .catch(function () { setAddLabel('error'); addState('error'); })
            .then(function () {
              addBtn.removeAttribute('aria-busy');
              setTimeout(function () {
                addBtn.disabled = false;
                setAddLabel('default');
                if (addTotalEl) addTotalEl.hidden = false;
              }, 1800);
            });
        });
      }

      if (mode === 'quote') {
        var quoteChips = card.querySelectorAll('[data-lp-quote-chips] .lp-pdp-buy-card__chip');
        var waCta = card.querySelector('[data-lp-wa-cta]');

        quoteChips.forEach(function (chip) {
          chip.addEventListener('click', function () {
            if (chip.getAttribute('aria-disabled') === 'true') return;
            quoteChips.forEach(function (c) {
              c.classList.remove('is-active');
              c.setAttribute('aria-pressed', 'false');
            });
            chip.classList.add('is-active');
            chip.setAttribute('aria-pressed', 'true');

            var presentation = chip.getAttribute('data-presentation') || '';
            card.setAttribute('data-lp-presentation', presentation);

            if (waCta) {
              var base = waCta.getAttribute('data-base-message') || '';
              var msg = base;
              if (presentation) {
                msg = base + ' (' + presentation + ')';
              }
              var hrefParts = waCta.href.split('?text=');
              if (hrefParts.length === 2) {
                var prefix = hrefParts[0];
                waCta.href = prefix + '?text=' + encodeURIComponent(msg);
              }
            }

            document.dispatchEvent(new CustomEvent('lp:presentation:change', {
              bubbles: true,
              detail: { value: presentation }
            }));
          });
        });

        var scrollCta = card.querySelector('[data-lp-quote-scroll]');
        if (scrollCta) {
          scrollCta.addEventListener('click', function (e) {
            var target = document.getElementById('cotizar');
            if (target) {
              e.preventDefault();
              var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              target.scrollIntoView({
                behavior: prefersReduced ? 'auto' : 'smooth',
                block: 'center'
              });
            }
          });
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var galleries = document.querySelectorAll('[data-lp-pdp-gallery]');
    if (!galleries.length) return;

    // Document-level listener for variant changes — bound exactly once across
    // the whole page, even if multiple galleries re-render or if the IIFE
    // runs again. Uses a flag on document so re-renders don't double-bind.
    if (!document.__lpPdpGalleryVariantBound) {
      document.__lpPdpGalleryVariantBound = true;
      document.addEventListener('lp:variant:change', function (e) {
        if (!e || !e.detail) return;
        var mediaId = e.detail.mediaId;
        if (mediaId === null || mediaId === undefined || mediaId === 0 || mediaId === '') return;
        var allGalleries = document.querySelectorAll('[data-lp-pdp-gallery]');
        allGalleries.forEach(function (g) {
          if (typeof g.__lpPdpSetActiveByMediaId === 'function') {
            g.__lpPdpSetActiveByMediaId(mediaId);
          }
        });
      });
    }

    galleries.forEach(function (gallery) {
      if (gallery.dataset.lpPdpGalleryInit === '1') return;
      gallery.dataset.lpPdpGalleryInit = '1';

      var thumbs = gallery.querySelectorAll('[data-lp-pdp-thumb]');
      var slides = gallery.querySelectorAll('[data-lp-pdp-slide]');
      var viewport = gallery.querySelector('[data-lp-pdp-viewport]');
      var desktopMql = window.matchMedia('(min-width: 900px)');
      var thumbList = gallery.querySelector('[data-lp-pdp-thumbs]');
      var railPrev = gallery.querySelector('[data-lp-pdp-rail-prev]');
      var railNext = gallery.querySelector('[data-lp-pdp-rail-next]');

      // Flechas del rail: cada una se muestra sólo si hay miniaturas ocultas
      // en esa dirección. El margen de 1px absorbe el redondeo de subpíxeles.
      function updateRailArrows() {
        if (!thumbList || !railPrev || !railNext) return;
        var maxScroll = thumbList.scrollWidth - thumbList.clientWidth;
        var left = thumbList.scrollLeft;
        railPrev.classList.toggle('lp-pdp-gallery__rail-btn--off', left <= 1);
        railNext.classList.toggle('lp-pdp-gallery__rail-btn--off', left >= maxScroll - 1);
      }

      function scrollRail(direction) {
        if (!thumbList) return;
        thumbList.scrollBy({
          left: direction * Math.max(thumbList.clientWidth * 0.75, 60),
          behavior: 'smooth'
        });
      }

      // Trae al rail la miniatura activada desde afuera (cambio de variante).
      // scrollTo sobre la lista y no scrollIntoView, que movería la página.
      function revealThumb(thumb) {
        if (!thumbList) return;
        var pad = 48;
        var itemStart = thumb.offsetLeft;
        var itemEnd = itemStart + thumb.offsetWidth;
        var viewStart = thumbList.scrollLeft;
        var viewEnd = viewStart + thumbList.clientWidth;
        if (itemStart < viewStart + pad) {
          thumbList.scrollTo({ left: Math.max(itemStart - pad, 0), behavior: 'smooth' });
        } else if (itemEnd > viewEnd - pad) {
          thumbList.scrollTo({ left: itemEnd - thumbList.clientWidth + pad, behavior: 'smooth' });
        }
      }

      if (thumbList && railPrev && railNext) {
        railPrev.addEventListener('click', function () { scrollRail(-1); });
        railNext.addEventListener('click', function () { scrollRail(1); });
        thumbList.addEventListener('scroll', updateRailArrows, { passive: true });
        // El alto del rail sigue al de la imagen principal, que cambia con el
        // ancho de la ventana: recalcular cada vez que la lista cambia de tamaño.
        if ('ResizeObserver' in window) {
          new ResizeObserver(updateRailArrows).observe(thumbList);
        } else {
          window.addEventListener('resize', updateRailArrows);
        }
        updateRailArrows();
      }

      function setActiveIndex(index) {
        thumbs.forEach(function (t) {
          var isActive = parseInt(t.dataset.index, 10) === index;
          t.classList.toggle('lp-pdp-gallery__thumb--active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        var counter = gallery.querySelector('[data-lp-pdp-counter]');
        if (counter) counter.textContent = index + 1;
      }

      // Slide-toggle approach (works for mixed image/video media). Replaces
      // the old in-place src swap which broke when the first slide was a
      // <video> (mutating its src destroyed the <source> children and froze
      // the gallery). Each slide stays in the DOM with its proper element
      // type (img / video / gif-img); we just toggle visibility via the
      // --active class that the CSS already styles. For videos we also
      // play/pause per slide so off-screen videos don't keep streaming.
      function switchToSlide(index) {
        slides.forEach(function (slide) {
          var slideIdx = parseInt(slide.dataset.index, 10);
          var isTarget = slideIdx === index;
          slide.classList.toggle('lp-pdp-gallery__slide--active', isTarget);
          slide.setAttribute('aria-hidden', isTarget ? 'false' : 'true');

          var video = slide.querySelector('video');
          if (video) {
            if (isTarget) {
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          }
        });
      }

      function activateThumb(thumb) {
        var index = parseInt(thumb.dataset.index, 10);
        if (isNaN(index)) return;
        switchToSlide(index);
        setActiveIndex(index);
      }

      function setActiveByMediaId(mediaId) {
        if (mediaId === null || mediaId === undefined || mediaId === 0 || mediaId === '') return false;
        var mediaIdStr = String(mediaId);
        var matchingThumb = null;
        thumbs.forEach(function (t) {
          if (matchingThumb) return;
          if (t.dataset.mediaId && t.dataset.mediaId === mediaIdStr) {
            matchingThumb = t;
          }
        });
        if (matchingThumb) {
          activateThumb(matchingThumb);
          revealThumb(matchingThumb);
          scrollToSlide(parseInt(matchingThumb.dataset.index, 10));
          return true;
        }
        return false;
      }

      // Expose for the document-level listener
      gallery.__lpPdpSetActiveByMediaId = setActiveByMediaId;

      var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

      // En mobile las fotos son un carrusel deslizable: la miniatura lo
      // lleva hasta su foto.
      function scrollToSlide(index) {
        if (!viewport || desktopMql.matches) return;
        var targetSlide = gallery.querySelector('[data-lp-pdp-slide][data-index="' + index + '"]');
        if (targetSlide) viewport.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(thumb);
          scrollToSlide(parseInt(thumb.dataset.index, 10));
        });
        if (canHover) {
          thumb.addEventListener('mouseenter', function () {
            activateThumb(thumb);
          });
        }
      });


      if (viewport && slides.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (desktopMql.matches) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = parseInt(entry.target.dataset.index, 10);
              if (isNaN(idx)) return;
              setActiveIndex(idx);
              var activeThumb = gallery.querySelector('[data-lp-pdp-thumb][data-index="' + idx + '"]');
              if (activeThumb) revealThumb(activeThumb);
            }
          });
        }, {
          root: viewport,
          threshold: [0.6]
        });
        slides.forEach(function (slide) {
          io.observe(slide);
        });
      }

      // Init: activar el slide inicial (el primero, o el que venga marcado
      // como activo del server) y REPRODUCIR su video. switchToSlide solo se
      // llamaba al cambiar de slide, así que el primer video quedaba en el
      // poster hasta hacer click en otra foto y volver.
      var lpActiveSlide = gallery.querySelector('.lp-pdp-gallery__slide--active');
      var lpInitIdx = lpActiveSlide ? parseInt(lpActiveSlide.dataset.index, 10) : 0;
      if (isNaN(lpInitIdx)) lpInitIdx = 0;
      switchToSlide(lpInitIdx);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-quote-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var roots = document.querySelectorAll('[data-lpp-quote-form]');
      if (!roots.length) return;

      roots.forEach(function (root) {
        if (root.hasAttribute('data-lp-bound')) return;
        root.setAttribute('data-lp-bound', '');

        // Focus the success card if present so SR users hear the
        // confirmation and visual users see the card on submit redirect.
        var successCard = root.querySelector('[data-lp-quote-success]');
        if (successCard) {
          try { successCard.focus({ preventScroll: false }); } catch (e) { successCard.focus(); }
          if (typeof successCard.scrollIntoView === 'function') {
            successCard.scrollIntoView({ block: 'center' });
          }
        }

        var presentationInput = root.querySelector('[data-lpp-presentation-input]');
        if (!presentationInput) return;

        function readPresentation() {
          var buyCard = document.querySelector('[data-lp-buy-card]');
          if (buyCard) {
            var dsAttr = buyCard.getAttribute('data-lp-presentation');
            if (dsAttr && dsAttr.length) return dsAttr;
            var dsHidden = buyCard.querySelector('[data-lpp-presentation-source]');
            if (dsHidden && dsHidden.value) return dsHidden.value;
          }
          var anyHidden = document.querySelector('[data-lpp-presentation-source]');
          if (anyHidden && anyHidden.value) return anyHidden.value;
          return '';
        }

        function sync() {
          var v = readPresentation();
          if (presentationInput.value !== v) {
            presentationInput.value = v;
          }
        }

        sync();

        var buyCard = document.querySelector('[data-lp-buy-card]');
        if (buyCard) {
          var observer = new MutationObserver(sync);
          observer.observe(buyCard, {
            attributes: true,
            attributeFilter: ['data-lp-presentation'],
            subtree: false
          });

          buyCard.addEventListener('change', sync, true);
          buyCard.addEventListener('click', function () {
            setTimeout(sync, 0);
          }, true);
        }

        document.addEventListener('lp:presentation:change', function (e) {
          if (e && e.detail && typeof e.detail.value === 'string') {
            presentationInput.value = e.detail.value;
          } else {
            sync();
          }
        });

        var form = root.querySelector('form');
        if (form) {
          form.addEventListener('submit', sync, true);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-related"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-lp-related-rail]').forEach(function (rail) {
      var list = rail.querySelector('[data-lp-related-list]');
      var nav = rail.querySelector('[data-lp-related-nav]');
      var prev = rail.querySelector('[data-lp-related-prev]');
      var next = rail.querySelector('[data-lp-related-next]');
      if (!list || !nav || !prev || !next) return;

      // 1px de margen para el redondeo de subpíxeles.
      function update() {
        var max = list.scrollWidth - list.clientWidth;
        nav.hidden = max <= 1;
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max - 1;
      }

      // Avanza de a casi una pantalla del riel; el snap acomoda la card.
      function go(direction) {
        list.scrollBy({ left: direction * list.clientWidth * 0.85, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var root = document.querySelector('[data-lp-pdp-sticky-bar]');
      if (!root) return;
      if (root.hasAttribute('data-lp-bound')) return;
      root.setAttribute('data-lp-bound', '');

      // Smooth-scroll on the quote-CTA anchor.
      var quoteLink = root.querySelector('[data-lp-pdp-sticky-bar-quote]');
      if (quoteLink) {
        quoteLink.addEventListener('click', function (event) {
          var hash = quoteLink.getAttribute('href') || '';
          if (hash.charAt(0) !== '#') return;
          var targetId = hash.slice(1);
          if (!targetId) return;
          var target = document.getElementById(targetId);
          if (!target) return;

          event.preventDefault();

          var prefersReducedMotion = false;
          if (window.matchMedia) {
            prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          }

          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });

          if (history && typeof history.replaceState === 'function') {
            history.replaceState(null, '', hash);
          }
        });
      }

      // Expose actual rendered height via CSS var so the section can pad
      // the footer / reserve space without hardcoding a magic number.
      function measureHeight() {
        var rect = root.getBoundingClientRect();
        var h = Math.ceil(rect.height || 0);
        document.documentElement.style.setProperty('--lp-sticky-bar-h', h + 'px');
      }
      measureHeight();
      window.addEventListener('resize', measureHeight);
      window.addEventListener('orientationchange', measureHeight);

      // Format money helper: mirrors the Liquid money filter when Shopify is
      // available, falls back to a best-effort UYU/locale-aware formatter.
      function formatMoney(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) return '';
        if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
          try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {}
        }
        var amount = (cents / 100);
        try {
          return amount.toLocaleString(undefined, { style: 'currency', currency: 'UYU' });
        } catch (e) {
          return '$' + amount.toFixed(2);
        }
      }

      // Products with volume tiers sell a MULTI-variant selection, not a unit:
      // once the volume block speaks it owns the price stack and the CTA, and
      // the per-variant broadcasts below stop applying.
      var volumeMode = false;
      var sbCompareEl = root.querySelector('[data-lp-sb-compare]');
      var sbCompareValueEl = root.querySelector('[data-lp-sb-compare-value]');

      document.addEventListener('lp:volume:change', function (e) {
        if (!e || !e.detail) return;
        volumeMode = true;

        var priceEl = root.querySelector('[data-lp-sb-price]');
        if (priceEl && e.detail.totalFormatted) {
          priceEl.textContent = e.detail.totalFormatted;
        }

        if (sbCompareEl && sbCompareValueEl) {
          if (e.detail.percentage > 0 && e.detail.subtotal > 0) {
            sbCompareValueEl.textContent = e.detail.subtotalFormatted || '';
            sbCompareEl.hidden = false;
          } else {
            sbCompareEl.hidden = true;
          }
        }

        var volumeCtaState = root.querySelector('[data-lp-sb-cta]');
        if (volumeCtaState) {
          if (e.detail.units === 0) {
            volumeCtaState.classList.add('is-unavailable');
            if ('disabled' in volumeCtaState) volumeCtaState.disabled = true;
            volumeCtaState.setAttribute('aria-disabled', 'true');
          } else {
            volumeCtaState.classList.remove('is-unavailable');
            if ('disabled' in volumeCtaState) volumeCtaState.disabled = false;
            volumeCtaState.removeAttribute('aria-disabled');
          }
        }

        measureHeight();
      });

      // Hand the CTA over to the volume block so the bar adds the WHOLE
      // selection (every presentation with qty > 0), not a single unit of the
      // variant that happens to sit in the hidden id input.
      var stickyForm = root.querySelector('form');
      var stickyCta = root.querySelector('[data-lp-sb-cta]');
      var stickyLabel = stickyCta ? stickyCta.querySelector('[data-lp-sb-label]') : null;
      var addBusy = false;

      function setAddState(state) {
        if (!stickyCta || !stickyLabel) return;
        var attr = { loading: 'data-adding-label', added: 'data-added-label', error: 'data-error-label' }[state] || 'data-add-label';
        stickyLabel.textContent = stickyCta.getAttribute(attr) || stickyLabel.textContent;
        if (state === 'loading') {
          addBusy = true;
          stickyCta.disabled = true;
          stickyCta.setAttribute('aria-busy', 'true');
          return;
        }
        stickyCta.removeAttribute('aria-busy');
        if (state === 'added' || state === 'error') {
          setTimeout(function () {
            addBusy = false;
            if (stickyCta.classList.contains('is-unavailable')) return;
            stickyCta.disabled = false;
            setAddState('default');
          }, 1800);
        }
      }

      // The volume block does the add itself; it reports back so the bar
      // shows the same feedback as a plain add.
      document.addEventListener('lp:volume:add-state', function (e) {
        if (e && e.detail && e.detail.state) setAddState(e.detail.state);
      });

      // La card de compra también avisa cómo va su "Agregar" (la barra le
      // delega el agregado para sumar los complementos marcados).
      document.addEventListener('lp:pdp:add-state', function (e) {
        if (e && e.detail && e.detail.state) setAddState(e.detail.state);
      });

      // Total de la card (precio × cantidad + complementos): manda sobre el
      // precio por variante de abajo.
      var totalMode = false;
      document.addEventListener('lp:pdp:total', function (e) {
        if (volumeMode || !e.detail || !e.detail.formatted) return;
        totalMode = true;
        var priceEl = root.querySelector('[data-lp-sb-price]');
        if (priceEl) priceEl.textContent = e.detail.formatted;
      });

      if (stickyForm) {
        stickyForm.addEventListener('submit', function (event) {
          var volumeCta = document.querySelector('[data-lp-volume-cta="cart"]');
          if (volumeCta) {
            event.preventDefault();
            if (!addBusy) volumeCta.click();
            return;
          }
          // Con la card en la página, agrega ella (producto + complementos
          // marcados, con su cantidad).
          var cardAdd = document.querySelector('[data-lp-buy-form] [data-lp-add-cart]');
          if (cardAdd && window.lpCart && typeof window.lpCart.addItems === 'function') {
            event.preventDefault();
            if (!addBusy && !cardAdd.disabled) cardAdd.click();
            return;
          }
          // La cantidad se elige en el stepper de la card de compra.
          var cardQty = document.querySelector('[data-lp-buy-form] [data-lp-qty-input]');
          var sbQty = stickyForm.querySelector('[data-lp-sb-qty]');
          if (cardQty && sbQty) {
            var q = parseInt(cardQty.value, 10);
            sbQty.value = isNaN(q) || q < 1 ? 1 : q;
          }

          // Agregar sin navegar a /cart. Sin el helper (lp-cart.js no cargó)
          // queda el envío nativo como respaldo.
          if (!window.lpCart || typeof window.lpCart.addItems !== 'function') return;
          event.preventDefault();
          if (addBusy) return;
          var idInput = stickyForm.querySelector('input[name="id"]');
          var id = idInput ? parseInt(idInput.value, 10) : NaN;
          if (isNaN(id)) return;

          setAddState('loading');
          window.lpCart.addItems([{ id: id, quantity: parseInt(sbQty ? sbQty.value : 1, 10) || 1 }])
            .then(function () { setAddState('added'); })
            .catch(function () { setAddState('error'); });
        });
      }

      // The volume block may have initialised before this listener existed —
      // ask it to re-broadcast rather than waiting for the first stepper tap.
      if (document.querySelector('[data-lp-volume]')) {
        volumeMode = true;
        document.dispatchEvent(new CustomEvent('lp:volume:sync'));
      }

      // Subscribe to variant changes broadcast by the buy-card. Updates the
      // hidden id, the displayed price, and the CTA availability label.
      document.addEventListener('lp:variant:change', function (e) {
        if (!e || !e.detail) return;
        if (volumeMode) return;
        var input = root.querySelector('input[name="id"]');
        if (input && e.detail.variantId) {
          input.value = e.detail.variantId;
        }
        var priceEl = root.querySelector('[data-lp-sb-price]');
        if (priceEl && !totalMode) {
          // Prefer pre-formatted money string from the event detail (rendered
          // server-side via the Liquid money filter, so it honors the
          // shop-level currency format, e.g. UYU "$1.680,00"). Fall back to
          // computing client-side only if priceFormatted is missing.
          if (typeof e.detail.priceFormatted === 'string' && e.detail.priceFormatted) {
            priceEl.textContent = e.detail.priceFormatted;
          } else if (typeof e.detail.variantPrice === 'number') {
            priceEl.textContent = formatMoney(e.detail.variantPrice);
          }
        }
        var cta = root.querySelector('[data-lp-sb-cta]');
        if (cta) {
          var labelEl = cta.querySelector('[data-lp-sb-label]');
          var addLabel = cta.getAttribute('data-add-label') || '';
          var soldOutLabel = cta.getAttribute('data-sold-out-label') || '';
          if (e.detail.available === false) {
            cta.classList.add('is-unavailable');
            if ('disabled' in cta) cta.disabled = true;
            cta.setAttribute('aria-disabled', 'true');
            if (labelEl && soldOutLabel) labelEl.textContent = soldOutLabel;
          } else {
            cta.classList.remove('is-unavailable');
            if ('disabled' in cta) cta.disabled = false;
            cta.removeAttribute('aria-disabled');
            if (labelEl && addLabel) labelEl.textContent = addLabel;
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-volume-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-lp-volume]');
    if (!roots.length) return;

    // Formats cents against the shop's money_format placeholder, so stores
    // using amount_with_comma_separator ($1.234,56) render correctly.
    function formatMoney(cents, format) {
      format = format || '${' + '{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var name = match ? match[1] : 'amount';
      var noDecimals = name.indexOf('no_decimals') !== -1;
      var commaDecimal = name.indexOf('comma_separator') !== -1;
      var amount = Math.round(cents) / 100;
      var fixed = noDecimals ? String(Math.round(amount)) : amount.toFixed(2);
      var pieces = fixed.split('.');
      var thousandsSep = commaDecimal ? '.' : ',';
      var out = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      if (pieces.length > 1) {
        out += (commaDecimal ? ',' : '.') + pieces[1];
      }
      return match ? format.replace(match[0], out) : out;
    }

    function setup(root) {
      if (root.getAttribute('data-lp-bound') === 'true') return;
      root.setAttribute('data-lp-bound', 'true');

      var moneyFormat = root.getAttribute('data-money-format');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lp-volume-row]'));
      if (!rows.length) return;

      var tiers = Array.prototype.slice
        .call(root.querySelectorAll('[data-lp-volume-tier]'))
        .map(function (el) {
          return {
            el: el,
            min: parseInt(el.getAttribute('data-tier-min'), 10) || 0,
            pct: parseFloat(el.getAttribute('data-tier-pct')) || 0
          };
        })
        .sort(function (a, b) {
          return a.min - b.min;
        });

      var unitsEl = root.querySelector('[data-lp-volume-units]');
      var badgeEl = root.querySelector('[data-lp-volume-badge]');
      var subtotalEl = root.querySelector('[data-lp-volume-subtotal]');
      var totalEl = root.querySelector('[data-lp-volume-total]');
      var savingsEl = root.querySelector('[data-lp-volume-savings]');
      var nudgeEl = root.querySelector('[data-lp-volume-nudge]');
      var errorEl = root.querySelector('[data-lp-volume-error]');
      var progressEl = root.querySelector('[data-lp-volume-progress]');
      var ctaTotalEl = root.querySelector('[data-lp-volume-cta-total]');
      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-lp-volume-cta]'));

      function t(key) {
        return root.getAttribute('data-t-' + key) || '';
      }

      function qtyInput(row) {
        return row.querySelector('[data-lp-volume-qty]');
      }

      function getQty(row) {
        var input = qtyInput(row);
        if (!input) return 0;
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 0) value = 0;
        return value;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function recompute() {
        var units = 0;
        var subtotal = 0;

        rows.forEach(function (row) {
          var qty = getQty(row);
          units += qty;
          subtotal += qty * (parseInt(row.getAttribute('data-price'), 10) || 0);
          if (qty > 0) {
            row.classList.add('is-selected');
          } else {
            row.classList.remove('is-selected');
          }
        });

        var applied = null;
        var next = null;
        tiers.forEach(function (tier) {
          if (units >= tier.min) {
            applied = tier;
          } else if (!next) {
            next = tier;
          }
        });

        tiers.forEach(function (tier) {
          if (applied && tier.min === applied.min) {
            tier.el.classList.add('is-active');
            tier.el.setAttribute('aria-current', 'true');
          } else {
            tier.el.classList.remove('is-active');
            tier.el.removeAttribute('aria-current');
          }
        });

        var pct = applied ? applied.pct : 0;
        var total = Math.round((subtotal * (100 - pct)) / 100);
        var savings = subtotal - total;

        // Barra: cuánto falta para la última escala.
        if (progressEl) {
          var top = tiers.length ? tiers[tiers.length - 1].min : 1;
          progressEl.style.width = Math.min(units / Math.max(top, 1), 1) * 100 + '%';
        }

        if (ctaTotalEl) {
          ctaTotalEl.textContent = units > 0 ? '\u00a0·\u00a0' + formatMoney(total, moneyFormat) : '';
        }

        if (unitsEl) {
          if (units === 1) {
            unitsEl.textContent = t('units-one');
          } else {
            unitsEl.textContent = t('units-many').replace('{count}', String(units));
          }
        }

        if (badgeEl) {
          if (pct > 0) {
            badgeEl.textContent = t('applied').replace('{pct}', String(pct));
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }

        if (subtotalEl) {
          if (pct > 0 && subtotal > 0) {
            subtotalEl.textContent = formatMoney(subtotal, moneyFormat);
            subtotalEl.hidden = false;
          } else {
            subtotalEl.hidden = true;
          }
        }

        if (totalEl) {
          totalEl.textContent = formatMoney(total, moneyFormat);
        }

        if (savingsEl) {
          if (savings > 0) {
            savingsEl.textContent = t('savings').replace('{amount}', formatMoney(savings, moneyFormat));
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }

        if (nudgeEl) {
          if (next && units > 0) {
            var missing = next.min - units;
            var template = missing === 1 ? t('nudge-one') : t('nudge-many');
            nudgeEl.textContent = template
              .replace('{count}', String(missing))
              .replace('{pct}', String(next.pct));
            nudgeEl.hidden = false;
          } else {
            nudgeEl.hidden = true;
          }
        }

        ctas.forEach(function (cta) {
          if (cta.getAttribute('aria-busy') === 'true') return;
          if (units === 0) {
            cta.disabled = true;
            cta.setAttribute('aria-disabled', 'true');
          } else {
            cta.disabled = false;
            cta.removeAttribute('aria-disabled');
          }
        });

        // The mobile sticky bar mirrors this summary — without it, it would
        // keep showing the unit price of whichever variant was last touched.
        document.dispatchEvent(new CustomEvent('lp:volume:change', {
          bubbles: true,
          detail: {
            units: units,
            percentage: pct,
            subtotal: subtotal,
            total: total,
            savings: savings,
            subtotalFormatted: formatMoney(subtotal, moneyFormat),
            totalFormatted: formatMoney(total, moneyFormat)
          }
        }));
      }

      // Keeps the gallery and the sticky bar pointed at the presentation the
      // customer is currently adjusting — they listen for lp:variant:change,
      // which the single-variant chips used to emit.
      function announceVariant(row) {
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        var price = parseInt(row.getAttribute('data-price'), 10);
        var mediaIdAttr = row.getAttribute('data-media-id');
        var mediaId = mediaIdAttr ? parseInt(mediaIdAttr, 10) : NaN;

        document.dispatchEvent(new CustomEvent('lp:variant:change', {
          bubbles: true,
          detail: {
            variantId: isNaN(variantId) ? null : variantId,
            variantPrice: isNaN(price) ? null : price,
            priceFormatted: row.getAttribute('data-price-money') || null,
            available: true,
            mediaId: isNaN(mediaId) ? null : mediaId
          }
        }));
      }

      rows.forEach(function (row) {
        var input = qtyInput(row);
        var dec = row.querySelector('[data-lp-volume-dec]');
        var inc = row.querySelector('[data-lp-volume-inc]');

        function setQty(value) {
          if (!input) return;
          var next = Math.max(0, value);
          input.value = next;
          clearError();
          recompute();
          if (next > 0) announceVariant(row);
        }

        if (dec) {
          dec.addEventListener('click', function () {
            setQty(getQty(row) - 1);
          });
        }
        if (inc) {
          inc.addEventListener('click', function () {
            setQty(getQty(row) + 1);
          });
        }
        if (input) {
          input.addEventListener('change', function () {
            setQty(getQty(row));
          });
          input.addEventListener('blur', function () {
            setQty(getQty(row));
          });
        }
      });

      function collectItems() {
        var items = [];
        rows.forEach(function (row) {
          var qty = getQty(row);
          if (qty <= 0) return;
          var id = parseInt(row.getAttribute('data-variant-id'), 10);
          if (!isNaN(id)) {
            items.push({ id: id, quantity: qty });
          }
        });
        return items;
      }

      function setBusy(cta, busy) {
        var label = cta.querySelector('[data-lp-volume-cta-label]');
        var ctaTotal = cta.querySelector('[data-lp-volume-cta-total]');
        if (ctaTotal) ctaTotal.hidden = busy;
        if (busy) {
          cta.setAttribute('aria-busy', 'true');
          cta.disabled = true;
          if (label) label.textContent = cta.getAttribute('data-label-loading') || label.textContent;
        } else {
          cta.removeAttribute('aria-busy');
          cta.disabled = false;
          if (label) label.textContent = cta.getAttribute('data-label-default') || label.textContent;
        }
      }

      ctas.forEach(function (cta) {
        cta.addEventListener('click', function () {
          clearError();
          var items = collectItems();
          if (!items.length) {
            showError(t('empty'));
            return;
          }

          // "Agregar al carrito" se queda en la página; solo "Comprar ahora"
          // navega (a /checkout).
          var toCheckout = cta.getAttribute('data-lp-volume-cta') === 'checkout';
          var reportState = function (state) {
            document.dispatchEvent(new CustomEvent('lp:volume:add-state', { detail: { state: state } }));
          };
          setBusy(cta, true);

          if (!toCheckout && window.lpCart && typeof window.lpCart.addItems === 'function') {
            reportState('loading');
            window.lpCart.addItems(items)
              .then(function () {
                var label = cta.querySelector('[data-lp-volume-cta-label]');
                if (label) label.textContent = cta.getAttribute('data-label-added') || label.textContent;
                reportState('added');
                setTimeout(function () { setBusy(cta, false); }, 1800);
              })
              .catch(function (err) {
                showError((err && err.message) || t('empty'));
                setBusy(cta, false);
                reportState('error');
              });
            return;
          }

          var destination = toCheckout ? '/checkout' : '/cart';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              return res.json().then(function (data) {
                return { ok: res.ok, data: data };
              });
            })
            .then(function (result) {
              if (!result.ok) {
                var message = (result.data && (result.data.description || result.data.message)) || t('empty');
                throw new Error(message);
              }
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'lp-pdp-volume-tiers', items: items, response: result.data }
              }));
              try {
                window.location.href = destination;
              } catch (e) {
                /* noop */
              }
            })
            .catch(function (err) {
              showError((err && err.message) || t('empty'));
              setBusy(cta, false);
            });
        });
      });

      // Lets a late-initialising listener (the sticky bar) ask for the current
      // state instead of waiting for the customer to touch a stepper.
      document.addEventListener('lp:volume:sync', function () {
        recompute();
      });

      recompute();
    }

    function init() {
      Array.prototype.forEach.call(roots, setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
